// ============================================================
// TATHYA DMS - Main App Router
// Version: 1.0.8
// Date: 2026-04-19
// ============================================================

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useParams } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/auth/Login';
import ChangePassword from './components/auth/ChangePassword';
import Layout from './components/layout/Layout';
import Dashboard from './components/dashboard/Dashboard';
import DatabaseList from './components/databases/DatabaseList';
import NewDatabase from './components/databases/NewDatabase';
import DatabaseView from './components/databases/DatabaseView';
import UserMaster from './components/users/UserMaster';
import ACL from './components/databases/ACL';
import AuditLog from './components/audit/AuditLog';
import ColumnManager from './components/databases/ColumnManager';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import AdminLogin from './components/admin/AdminLogin';
import AdminDashboard from './components/admin/AdminDashboard';
import UpdateBanner from './components/layout/UpdateBanner';
import PublicView from './components/databases/PublicView';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const { org_slug } = useParams();
  if (!user) return <Navigate to={`/${org_slug}/login`} replace />;
  return <Layout>{children}</Layout>;
};

const App = () => {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/consam/login" replace />} />
          <Route path="/:org_slug/login" element={<Login />} />
          <Route path="/:org_slug/change-password" element={<ChangePassword />} />
          <Route path="/:org_slug/account/change-password" element={
            <ProtectedRoute><ChangePassword /></ProtectedRoute>
          } />
          <Route path="/:org_slug/forgot-password" element={<ForgotPassword />} />
          <Route path="/:org_slug/reset-password" element={<ResetPassword />} />
          <Route path="/:org_slug/db/:db_number" element={<PublicView />} />
          <Route path="/:org_slug/dashboard" element={
            <ProtectedRoute><Dashboard /></ProtectedRoute>
          } />
          <Route path="/:org_slug/databases" element={
            <ProtectedRoute><DatabaseList /></ProtectedRoute>
          } />
          <Route path="/:org_slug/databases/new" element={
            <ProtectedRoute><NewDatabase /></ProtectedRoute>
          } />
          <Route path="/:org_slug/databases/:db_id" element={
            <ProtectedRoute><DatabaseView /></ProtectedRoute>
          } />
          <Route path="/:org_slug/databases/:db_id/permissions" element={
            <ProtectedRoute><ACL /></ProtectedRoute>
          } />
          <Route path="/:org_slug/databases/:db_id/audit" element={
            <ProtectedRoute><AuditLog /></ProtectedRoute>
          } />
          <Route path="/:org_slug/databases/:db_id/columns" element={
            <ProtectedRoute><ColumnManager /></ProtectedRoute>
          } />
          <Route path="/:org_slug/users" element={
            <ProtectedRoute><UserMaster /></ProtectedRoute>
          } />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="*" element={<Navigate to="/consam/login" replace />} />
        </Routes>
      <UpdateBanner />
      </BrowserRouter>
    </AuthProvider>
  );
};

export default App;
